
import * as storyblokRuntime$_D8rz3sgITDy3o_4uoFSVMVhq3dFDFlwQB4sxoS_45G_45E from '/codebuild/output/src1713749389/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.10.0_@netlify+blobs@8.2.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$bCk9ki0ze10UPle88WNYs4e19ChYqgbBrP4VHYIfoS0 from '/codebuild/output/src1713749389/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.10.0_@netlify+blobs@8.2.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$_D8rz3sgITDy3o_4uoFSVMVhq3dFDFlwQB4sxoS_45G_45E, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$bCk9ki0ze10UPle88WNYs4e19ChYqgbBrP4VHYIfoS0, defaults: {} }
}
        